import Vue from 'vue';
import Vuex from 'vuex';
import {
    setStore,
    getStore,
    removeStore,
    modifyJson
} from '@/config/mUtils'
import {
    authority
} from "@/config/authority";
Vue.use(Vuex)
//全局变量
const state = {
    //页面加载时
    pageLoading: false,
    //数据加载时
    dataLoading: false,
    //当前页面路径
    routerUrl: '',
    //用户信息
    userInfo: {},
    //页面数据储存
    pageData: {},
    newdata: [],
    refreshList: [],  //刷新的页面
    keepAliveRoute:["examManage"],//
}
//缓存浏览器的数据名称
const cacheNameList = ["userInfo", "pageData", "newdata"];
var copyState = deepCopy(state);  //拷贝state对象
//数据处理
const mutations = { //触发状态
    // 还原state数据
    mResState(state) {
        for (var i in copyState) {
            state[i] = copyState[i]  // 递归赋值
        }
    },
    //取出缓存数据
    setCacheData(state) {
        for (var item of cacheNameList) {
            let getData = sessionStorage.getItem(item);
            if (getData) {
                state[item] = JSON.parse(getData);
            }
        }
    },
    //页面加载时
    setPageLoading(state, payload) {
        state.pageLoading = payload;
    },
    //数据加载时
    setDataLoading(state, payload) {
        state.dataLoading = payload;
    },
    //当前页面路径
    setPath(state, payload) {
        state.routerUrl = payload;
    },
    //储存用户信息
    setUserInfo(state, payload) {
        if (payload) {
            state.userInfo = modifyJson(payload, state.userInfo);
            setStore('userInfo', state.userInfo);
            state.newdata = payload.newdata;
            setStore('newdata', state.newdata);
        }
    },
    //页面数据储存
    setPageData(state, payload) {
        if (payload) {
            state.pageData = modifyJson(payload, state.pageData);
            setStore('pageData', state.pageData);
        }
    },
    // 添加要刷新的页面
    setRefreshList(state, name) {
        let exists = false;
        state.refreshList.forEach((item, index) => {
            if (name == item) {
                exists = true;
            }
        })
        if (!exists) {
            state.refreshList.push(name);
        }
    },
    // 清空刷新页面列表
    empty(state, arr) {
        state.refreshList = [];
    },
    //更新userInfo的数据
    updateInfo(state, payload) {
        state.userInfo[payload.name] = payload.value
        setStore('userInfo', state.userInfo);
    },
    //更新newdata的数据
    updateNewDataInfo(state, payload) {
        setStore('newdata',payload.value);
    },
}
//异步处理
const actions = {

}
function deepCopy(p, c) {
    var c = c || {};
    for (var i in p) {
        if (typeof p[i] === 'object') {
            c[i] = (p[i].constructor === Array) ? [] : {};
            deepCopy(p[i], c[i]);
        } else {
            c[i] = p[i];
        }
    }
    return c;
}

export default new Vuex.Store({
    strict: process.env.NODE_ENV !== 'production',
    state,
    mutations,
    actions
})



// WEBPACK FOOTER //
// ./src/config/store.js